<span>
  <div [class]="'job-tag-wrapper'">
    <div [class]="'job-tag'">
      <span class="tags">
        <span *ngIf="tagShape?.asset" [innerHTML]="sanitizeSVGString(tagShape?.coloredAsset)"></span>
        <span class="mx-1">{{ tag?.label }}</span>
        <img
          *ngIf="removable && isAllowed('job_board_attributes', 'edit')"
          (click)="deleteTag()"
          style="cursor: pointer"
          src="/assets/images/icon/close_gray.svg" />
      </span>
    </div>
  </div>
</span>
